import React, {useEffect, useState} from 'react';
import axios from 'axios';
import {Link, useNavigate, useParams} from 'react-router-dom';
import {Card, Spinner, Alert, Button, Footer} from 'react-bootstrap';
import loaderimage from "../../images/giphy.gif";
import ConfirmationModal from '../shared/ConfirmationModal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AllFailureModal from '../shared/AllFailureModal';
import NewconfirmationModal from '../shared/NewconfirmationModal';

const JobDetailedDescription = () => {
  const {jobid} = useParams();
  const [job, setJob] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [operationType, setOperationType] = useState("");
  const [onConfirm, setOnConfirm] = useState(null);

  const [selectedJobId, setSelectedJobId] = useState(null);
  const [actionType, setActionType] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");

  const deleteWholeJob = (id) => {
    setModalMessage("Sure you want to delete Job?");
    setOperationType("Delete");
    setOnConfirm(() => async () => {
      try {
        const url = process.env.REACT_APP_API_URL + `job_details/deletewholejob_details/${id}`;
        await axios.put(url, {});
        setSuccessMessage("Job deleted successfully!");
        setShowSuccessModal(true);
        setTimeout(() => navigate("/joblist"), 3000);
      } catch (error) {
        console.error("Error deleting Job:", error);
        setFailureMessage("Error deleting Job.");
        setShowFailureModal(true);
      }
    });
    setShowModal(true);
  };

  const handleAction = async () => {
    if (!selectedJobId) return;

    try {
      let url = "";
      if (actionType === "Activate") {
        url = `${process.env.REACT_APP_API_URL}jobs/activatejob/${selectedJobId}`;
        await axios.put(url);
        setSuccessMessage("Job activated successfully.");
      } else if (actionType === "Deactivate") {
        url = `${process.env.REACT_APP_API_URL}jobs/deactivatejob/${selectedJobId}`;
        await axios.put(url);
        setSuccessMessage("Job deactivated successfully.");
      }
      
      // Refresh job data after action
      const refreshUrl = `${process.env.REACT_APP_API_URL}job_details/detaileddescription/${jobid}`;
      const response = await axios.get(refreshUrl);
      setJob(response.data);
      
      setShowSuccessModal(true);
    } catch (error) {
      console.error("Action error:", error);
      const errorMessage = error.response?.status === 404 
        ? `Failed to ${actionType.toLowerCase()} job. Job not found.`
        : `Failed to ${actionType.toLowerCase()} job. ${error.message || ""}`;
      setFailureMessage(errorMessage);
      setShowFailureModal(true);
    } finally {
      setShowModal(false);
      setSelectedJobId(null);
    }
  };

  const triggerActionModal = (action, jobId) => {
    setSelectedJobId(jobId);
    setActionType(action);
    if (action === "Activate") {
      setModalMessage("Are you sure you want to activate this job?");
    } else if (action === "Deactivate") {
      setModalMessage("Are you sure you want to deactivate this job?");
    }
    setOperationType(action);
    setOnConfirm(() => handleAction);
    setShowModal(true);
  };

  useEffect(() => {
    const getJobDetailedDescriptionByIDApi = async (jobid) => {
      try {
        const url = `${process.env.REACT_APP_API_URL}job_details/detaileddescription/${jobid}`;
        const response = await axios.get(url);
        setJob(response.data);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setError("Job details not found ! please create ");
        } else {
          setError("An error occurred while fetching the job details.");
        }
      } finally {
        setLoading(false);
      }
    };

    getJobDetailedDescriptionByIDApi(jobid);
  }, []);

  if (error) {
    return (
      <Alert variant="danger">
        {error}
        <div className="mt-3">
          <Button variant="primary" onClick={() => navigate(`/jobdetailsadd/${jobid}`)}>
            Create Job Deatils
          </Button>
        </div>
      </Alert>
    );
  }

  const dangerStyle = {
    display: 'inline-block',
    padding: '0.375rem 0.75rem',
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1.5',
    textAlign: 'center',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    borderRadius: '0.25rem',
    border: '1px solid transparent',
    transition: 'color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out',
    cursor: 'pointer',
    color: '#fff',
    backgroundColor: '#dc3545',
    borderColor: '#dc3545',
  };
  return (
    <>
    <ToastContainer/>
    <div className="container mt-5">
      <>
        <h1 className="text-center mb-4 text-primary">Job Details</h1>
        <Card className="shadow-lg border-light">
          <Card.Header as="h5" className="bg-primary text-white text-center py-3">
            Job ID: <span className="font-weight-normal">{job.job_id}</span>
          </Card.Header>
          <Card.Body className="p-4 bg-light">
            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Job Name:</div>
              <div className="col-md-8 text-dark">{job.job_name}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">HR Name:</div>
              <div className="col-md-8 text-dark">{job.hr_name}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Number of Positions:</div>
              <div className="col-md-8 text-dark">{job.number_of_positions}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Job Highlights:</div>
              <div className="col-md-8">
                <div className="border border-primary p-3 rounded bg-white"
                     dangerouslySetInnerHTML={{__html: job.job_highlights}}/>
              </div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Job Description:</div>
              <div className="col-md-8">
                <div className="border border-success p-3 rounded bg-white"
                     dangerouslySetInnerHTML={{__html: job.job_description}}/>
              </div>
            </div>

              <div className="row mb-4">
                <div className="col-md-4 font-weight-bold text-secondary">Skills:</div>
                <div className="col-md-8">
                  {job.skills ? (() => {
                    let skillsArray = [];

                    if (typeof job.skills === "string") {
                      try {
                        const parsed = JSON.parse(job.skills);
                        skillsArray = Array.isArray(parsed) ? parsed : [];
                      } catch (err) {
                        console.error("Invalid JSON in job.skills:", err);
                        return <p>Invalid skill data</p>;
                      }
                    } else if (Array.isArray(job.skills)) {
                      skillsArray = job.skills;
                    }

                    return skillsArray.length > 0 ? (
                      skillsArray.map((skill, index) => (
                        <span
                          key={skill.skill_id || index}
                          className="badge bg-primary me-2 mb-2 d-inline-flex align-items-center"
                        >
                          <span className="d-flex flex-column">
                            <span>{skill.skill_name}</span>
                            <small className="text-white-50">
                            </small>
                          </span>
                        </span>
                      ))
                    ) : (
                      <p>No skills available</p>
                    );
                  })() : (
                    <p>No skills available</p>
                  )}
                </div>

              </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Job Category:</div>
              <div className="col-md-8 text-dark">{job.primary_industry}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Department:</div>
              <div className="col-md-8 text-dark">{job.department}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Role:</div>
              <div className="col-md-8 text-dark">{job.role}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Job Type:</div>
              <div className="col-md-8 text-dark">{job.job_type}</div>
            </div>
            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Qualification:</div>
              <div className="col-md-8 text-dark">{job.qualification}</div>
            </div>
            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Experience:</div>
              <div className="col-md-8 text-dark">{job.experience}</div>
            </div>
            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Package:</div>
              <div className="col-md-8 text-dark">{job.package}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Address</div>
              <div className="col-md-8 text-dark">{job.address}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">City</div>
              <div className="col-md-8 text-dark">{job.city_name}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">State</div>
              <div className="col-md-8 text-dark">{job.state_name}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Country</div>
              <div className="col-md-8 text-dark">{job.country_name}</div>
            </div>

            {job.post_code && <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Postal Code</div>
              <div className="col-md-8 text-dark">{job.post_code}</div>
            </div>}
            {job.job_external_url && <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Job External URL:</div>
              <div className="col-md-8">
                <a href={job.job_external_url} target="_blank" rel="noopener noreferrer" className="text-primary">
                  {job.job_external_url}
                </a>
              </div>
            </div>}

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Post Date:</div>
              <div className="col-md-8 text-dark">{new Date(job.post_date).toLocaleDateString()}</div>
            </div>

            <div className="row mb-4">
              <div className="col-md-4 font-weight-bold text-secondary">Job Active:</div>
              <div className="col-md-8 text-dark">{job.job_status == 1 ? 'Yes' : 'No'}</div>
            </div>

            <div className="row">
              <div className="text-center mb-4">
                {job.job_status === 1 ? (
                  <button
                    className="btn btn-danger"
                    onClick={() => triggerActionModal("Deactivate", job.job_id)}
                    style={{ marginRight: '10px' }}
                  >
                    Deactivate
                  </button>
                ) : (
                  <button
                    className="btn btn-success"
                    onClick={() => triggerActionModal("Activate", job.job_id)}
                    style={{ marginRight: '10px' }}
                  >
                    Activate
                  </button>
                )}
                <Link to={`/jobdetailsupdate/${job.job_id}`} className="btn btn-primary" style={{ marginRight: '10px' }}>Edit Job Details</Link>
                <Link to={`/jobupdate/${job.job_id}`} className="btn btn-warning" style={{ marginRight: '10px' }}>Edit Job</Link>
                <button onClick={() => deleteWholeJob(job.job_id)} className="btn btn-danger" style={{ marginRight: '10px' }}>Delete</button>
                <Link to={`/joblist`} className="btn btn-secondary">Go back</Link>
              </div>
            </div>
          </Card.Body>
        </Card>
      </>

      {loading && (
        <div className="loader">
          <img src={loaderimage} alt="Loader"/>
        </div>
      )}
      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalMessage={modalMessage}
        operationType={operationType}
        confirmation={handleAction}
      />
      <NewconfirmationModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        modalMessage={successMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
      <AllFailureModal
        show={showFailureModal}
        onHide={() => setShowFailureModal(false)}
        modalMessage={failureMessage}
        operationType="OK"
        timeoutDuration={3000}
      />
    </div>
  </>
  );
};

export default JobDetailedDescription;
